import { useAxiosContext } from '@dc-shared-web/providers'
import { AxiosInstance } from 'axios'
import { useQuery } from 'react-query'
import { GetAllProvisionsResult } from '@dc-shared-web/hooks/api/provision/types'

const fetchAllProvisions = async (
  apiClient: AxiosInstance
): Promise<GetAllProvisionsResult> => {
  const { data } = await apiClient.get<GetAllProvisionsResult>(
    `/ajax/provisions/find`,
    {
      params: { all: 'true' },
    }
  )

  return data
}

export const useGetAllProvisions = () => {
  const apiClient = useAxiosContext()

  return useQuery<GetAllProvisionsResult, Error>({
    queryKey: ['provisions-get-all'],
    queryFn: () => fetchAllProvisions(apiClient),
    initialData: { results: [], status: 'idk', pagination: { more: false } },
  })
}
